export const AGENCY_USER = 'AGENCY_USER';
export const AGENT = 'AGENT';
export const CARRIER = 'CARRIER';
export const MEMBER = 'MEMBER';
